module.exports = __webpack_public_path__ + "static/media/logo-dual-grey@3x.2441e0d7.png";